// Modèle d'event unifié de TOUS les jobs asynchrones (miroir de net.hifivework.hfwcore.job.JobProgress).
// Circule sur Kafka + SSE. Les features dérivent leurs vues (EVP, OCR, onboarding) de ce type.

export type JobType =
  | 'ONBOARDING_CLIENT'
  | 'EVP_SEND'
  | 'PAYSLIP_SYNC'
  | 'PAYSLIP_OCR';

export type JobState =
  | 'PROCESSING'
  | 'WAITING_USER'
  | 'SUCCESS'
  | 'ERROR'
  | 'CANCELLED';

export type StepState =
  | 'PENDING'
  | 'RUNNING'
  | 'SUCCESS'
  | 'FAILED'
  | 'SKIPPED'
  | 'WAITING_USER';

export type JobError = {
  step?: string;
  label?: string;
  reference?: string;
  message?: string;
};

export type JobStepProgress = {
  type: string;
  label?: string;
  state: StepState;
  // compteurs libres par feature : EVP {sent,created,updated,failed,skipped}, BS {retrieved,notFound,failed},
  // OCR {total,done,failed}, etc.
  counters: Record<string, number>;
  errorMessage?: string;
};

export type JobProgress = {
  jobId: string;
  companyId: string;
  jobType: JobType;
  provider?: string;
  state: JobState;
  currentStepIndex: number;
  steps: JobStepProgress[];
  errors?: JobError[];
  errorMessage?: string;
};

/** Lecture défensive d'un compteur d'étape (0 si absent). */
export function jobStepCounter(
  step: JobStepProgress | undefined,
  key: string
): number {
  return step?.counters?.[key] ?? 0;
}

/** Vrai si l'état est terminal (le SSE se ferme après). */
export function isJobTerminal(state: JobState): boolean {
  return state === 'SUCCESS' || state === 'ERROR' || state === 'CANCELLED';
}
